/**
 * useChannelValidation - Per-Asset Validierung fuer einen Channel
 */

import { useQuery } from '@tanstack/react-query'
import apiClient from '@/lib/api-client'

export interface AssetValidationError {
  field: string
  message: string
  expected: string | null
  actual: string | null
}

interface ValidationResult {
  asset_id: string
  is_valid: boolean
  errors: AssetValidationError[]
}

interface ValidationResponse {
  success: boolean
  is_valid: boolean
  validation_results: ValidationResult[]
}

export function useChannelValidation(productId: string | null, channelId: string | null) {
  return useQuery({
    queryKey: ['channel-validation', productId, channelId],
    queryFn: async () => {
      const res = await apiClient.get<ValidationResponse>(
        `/api/v1/products/${productId}/channels/${channelId}/validate`
      )
      return res.data
    },
    enabled: !!productId && !!channelId,
    staleTime: 15_000,
  })
}

/** Extrahiert Fehler fuer ein einzelnes Asset aus den Validierungsergebnissen. */
export function getAssetErrors(
  validationResults: ValidationResult[] | undefined,
  assetId: string
): AssetValidationError[] {
  if (!validationResults) return []
  const result = validationResults.find((r) => r.asset_id === assetId)
  return result?.errors ?? []
}
